module.exports = __webpack_public_path__ + "static/media/no-result.e1457eaf.svg";